export default __webpack_public_path__ + "static/media/completed.7e7af9e4.svg";